
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/oembed/videos",
      function () {
        return require("private-next-pages/apipages/oembed/videos/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/oembed/videos"])
      });
    }
  